import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { config } from '../config';
import { prepareHeaders } from '../configuration/tokenHandling/prepareHeaders';
import type { AppInfo, AppResponse } from './appsMapper';

export const appsApi = createApi({
    reducerPath: 'appsApi',
    baseQuery: fetchBaseQuery({ baseUrl: config.backend.APPS_URL, prepareHeaders }),
    endpoints: builder => ({
        fetchApps: builder.query<AppInfo[], string | undefined>({
            query: locale => `?locale=${locale}`,
            transformResponse: (response: AppResponse) => response.items.map(({ id }) => ({ id })),
            keepUnusedDataFor: 100,
        }),
    }),
});

// Export hooks for usage in function components which are
// auto-generated based on defined endpoints
export const { useFetchAppsQuery } = appsApi;
